module.exports = __webpack_public_path__ + "img/robux.11710d5d.png";